<template>

  <div class="box-table">
    <div class="horizontal-responsive">
      <table class="table-investment">
        <tr>
          <th>ID</th>
          <th>Banco</th>
          <th>Clabe</th>
          <th>Estado</th>
        </tr>
        <tr v-for="clabe in clabeList.results" :key="clabe.id">
          <td>{{ clabe.id }}</td>
          <td>{{ clabe.bank_name }}</td>
          <td>{{ clabe.clabe }}</td>
          <td v-if="clabe.is_valid === true">Activa</td>
          <td v-else>Inactiva</td>
        </tr>
      </table>
      <p class="-centered-info"><small>{{ currentPage }} de {{ totalPages }}</small></p>
    </div>
    <div class="table-pagination -centered-info">
      <button
        class="button button-small"
        @click="paginationTable(clabeList.previous, 'previous')"
        :disabled="clabeList.previous === null">Anterior</button>
      <button
        class="button button-small"
        @click="paginationTable(clabeList.next)"
        :disabled="clabeList.next === null">Siguiente</button>
    </div>
  </div>

</template>

<script>

import { format } from 'date-fns'
import mixins from '@/mixins/index'
import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'InvestorClabeTable',
  data () {
    return {
      format,
      clabeList: {},
      totalPages: 1,
      currentPage: 1
    }
  },
  props: { object: Object },
  mixins: [mixins, httpRequestMixin],
  methods: {
    paginationTable: async function (url, type = 'next') {
      if (type === 'next') {
        this.currentPage++
      } else {
        this.currentPage--
      }

      let options = {
        method: 'GET',
        url: this.checkProtocol(url),
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }
      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.clabeList = response.data
        this.doScroll(100)
      }
    }
  },
  created: function () {
    this.clabeList = this.object
    if (this.clabeList.count >= 10) {
      this.totalPages = Math.ceil(this.clabeList.count / 10)
    }
  }
}

</script>

<style lang="scss">

.table-pagination {
  margin-top: 2rem;
}

.table-investment {

  td,
  th {
    font-size: .9em;
    line-height: 1.2;
  }
  th b {
    color: #999;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/investorClabe/InvestorClabeTable.vue